/*
 * @Author: your name
 * @Date: 2021-07-20 14:18:36
 * @LastEditTime: 2021-07-22 18:21:25
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \admine:\LBB\front_end_nest_app_project\src\utils\api.js
 */
import request from '@/utils/server.js'
import { getUUID } from "@/utils/auth.js";

// 商家报价落地页配置的店铺信息
export function getQuotationLandStore(data) {
    return request({
        url: `/zuul/yuanyaotech-cloud-service-quotation/admin/uBusineStore/queryQuotationLandStore`,
        method: 'get',
        data: data
    })
}
// 商家报价落地页豆粕列表
export function getDouQuotationList(data) {
    return request({
        url: `/zuul/yuanyaotech-cloud-service-quotation/wap/quotation/storeQuotationList`,
        method: 'post',
        data: data
    })
}
// 商家报价落地页玉米列表
export function getCornStoreQuotationList(data) {
    return request({
        url: `/zuul/yuanyaotech-cloud-service-cornQuotation/wap/cornQuotation/cornStoreQuotationList`,
        method: 'post',
        data: data
    })
}
// 商家报价落地页小麦列表
export function getWheatStoreQuotationList(data) {
    return request({
        url: `/zuul/yuanyaotech-cloud-service-cornQuotation/wap/wheatQuotation/wheatStoreQuotationList`,
        method: 'post',
        data: data
    })
}
// 商家报价落地页获取活动规则
export function getStoreQuotationRules(data) {
    return request({
        url: `/zuul/yuanyaotech-cloud-service-quotation/wap/quotation/storeQuotationRules`,
        method: 'get',
        data: data
    })
}
// WEBSOCKETINFO: '/zuul/yuanyaotech-front/sys/config/info', // websocket链接地址 
export function websocketPush(data) {
    return request({
        url: `/zuul/yuanyaotech-front/sys/config/info?key=${data.WEBSOCKET_VISIT_URL}`,
        method: 'get',
        data: data
    })
}
// 获取图片验证码
export function getImgCode() {
    let uuid = getUUID();
    return {
        img: `${location.origin}/zuul/yuanyaotech-cloud-service-quotation/wap/quotation/captcha.jpg?uuid=${uuid}`,
        uuid: uuid
    }

}
// 验证码验证并获取店铺信息
export function verification(data) {
    return request({
        url: `/zuul/yuanyaotech-cloud-service-quotation/wap/quotation/verification`,
        method: 'post',
        data: data
    })
}


// WEBPACK FOOTER //
// ./src/utils/api.js